import { isObject, replaceObject } from './util_helpers';
import moment from 'moment-timezone';
import * as RNLocalize from 'react-native-localize';

import DATA from '../configs/config_data';

export function getConvertedTimezone(timezone) {
    const newTimezone = replaceObject(timezone || '', DATA.replaceTimezone);
    return(newTimezone ? (DATA.timezoneData.find((item) => item.toLowerCase() === newTimezone.toLowerCase()) ? newTimezone : 'America/Denver') : 'America/Denver');
}

export function toTimezoneMoment(dateString, timezone = 'America/Denver') {
    return(moment.tz(dateString, timezone));
}
// endregion

function isInstanceInException(eventData = {}, instanceMoment = {}) {
    const checkingMoment = instanceMoment.clone().utc();
    return(
        !!(eventData['calendar_exceptions'] || []).find((item) => item.date === checkingMoment.format('YYYY-MM-DD'))
    );
}

/**
 * Get the next event instance
 * @param calendarObj {object} - The event object, should be containing key fields like: start_time, end_time and timezone
 * @param ignoreTimezone {boolean} - Whether to parse the date data to current device's timezone
 */
export function getNextEventInstance(calendarObj = {}, ignoreTimezone = false) {
    // Convert timezone - Moment objects
    let deviceTimezone = RNLocalize.getTimeZone(),
        convertedTimezone = getConvertedTimezone(calendarObj['timezone']),
        nowMoment = moment().tz(deviceTimezone);

    let startMoment =
        ignoreTimezone ?
            moment(calendarObj['start_time'], 'YYYY-MM-DD HH:mm:ss')
            :
            toTimezoneMoment(calendarObj['start_time'], convertedTimezone).tz(deviceTimezone);

    let endMoment =
        ignoreTimezone ?
            moment(calendarObj['end_time'], 'YYYY-MM-DD HH:mm:ss')
            :
            toTimezoneMoment(calendarObj['end_time'], convertedTimezone).tz(deviceTimezone);

    // Check for frequency symbol
    let freq = calendarObj.frequency ? (isObject(calendarObj.frequency) ? calendarObj.frequency.name.toLowerCase() : calendarObj.frequency.toLowerCase()) : 'once',
        momentSymbol = freq === 'yearly' ? 'y' : (freq === 'weekly' ? 'w' : (freq === 'monthly' ? 'M' : 'd')),
        intervalCount = calendarObj?.interval || 1,
        resultObj = null;

    const createTimeObj = (startUnix, endUnix, diffCount = 1) => {
        let currentUnix = nowMoment.unix(),
            timeDifferenceStart = startUnix - currentUnix;

        return(
            {
                diffCount,

                startTime: startUnix,
                endTime: endUnix,

                utcDateStr: moment.unix(startUnix).utc().format('YYYY-MM-DD'),

                onGoing: (currentUnix >= startUnix) && (currentUnix <= endUnix),

                isOver: currentUnix > endUnix,

                in24h: ((timeDifferenceStart >= 0) && (timeDifferenceStart <= 86400)),
                in15h: ((timeDifferenceStart >= 0) && (timeDifferenceStart <= 54000)),
                isSameDay: moment.unix(startUnix).isSame(moment.unix(endUnix), 'day'),
                startDateText: moment.unix(startUnix).format('YYYY-MM-DD HH:mm:ss'),
                timeStr:
                    startUnix >= currentUnix ?
                        'Starting ' + moment.unix(startUnix).fromNow()
                        :
                        (
                            endUnix >= currentUnix ?
                                'Ending '
                                :
                                'Ended '
                        )
                        + moment.unix(endUnix).fromNow()
            }
        );
    };

    if (freq === 'once') {
        resultObj = createTimeObj(startMoment.unix(), endMoment.unix());
    }
    else {
        // Check the 1st instance first
        if (
            (
                startMoment.isSameOrAfter(nowMoment) ||
                (nowMoment.isSameOrAfter(startMoment) && nowMoment.isSameOrBefore(endMoment))
            )
            &&
            !isInstanceInException(calendarObj, startMoment)
        ) {
            resultObj = createTimeObj(startMoment.unix(), endMoment.unix());
        }
        else {
            let diffCount = nowMoment.diff(endMoment, momentSymbol) + 1;
            if (isInstanceInException(calendarObj, startMoment.clone().add(diffCount, momentSymbol))) {
                diffCount += 1;
            }

            const isStillValid = !calendarObj['times_repeated'] ? true : ((diffCount / intervalCount) <= (calendarObj['times_repeated'] + 1));

            if (isStillValid) {
                let currentEventInstanceStart = startMoment.add(diffCount, momentSymbol),
                    currentEventInstanceEnd = endMoment.add(diffCount, momentSymbol);

                resultObj = createTimeObj(currentEventInstanceStart.unix(), currentEventInstanceEnd.unix(), diffCount);
            }
        }
    }

    return(resultObj);
}
// endregion
